document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.moko-tracker-cta-banner__video');

  if (!videos.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting && video.paused) {
        video.play().catch(() => {});
      }
    });
  }, { threshold: 0.25 });

  videos.forEach((video) => observer.observe(video));
});
